// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"193":"app-messages-fr_CA","661":"question-sets-metadata","914":"app-messages-en_CA"}[chunkId] + "." + {"193":"50332f42","661":"c3dd5c0a","914":"8d4a4666"}[chunkId] + ".chunk.js";
};